import { render, staticRenderFns } from "./powerPoint.vue?vue&type=template&id=cc52ec7e&scoped=true"
import script from "./powerPoint.vue?vue&type=script&lang=js"
export * from "./powerPoint.vue?vue&type=script&lang=js"
import style0 from "./powerPoint.vue?vue&type=style&index=0&id=cc52ec7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc52ec7e",
  null
  
)

export default component.exports